module.exports = __webpack_public_path__ + "static/media/logo.212bfed8.png";